import BigNumber from 'bignumber.js';

import { ApiTask, ApiTaskResponse } from './types';

export function convertApiTaskResponse({
  admin,
  // eslint-disable-next-line camelcase
  upkeep_id,
  contract,
  hash,
  name,
  amount,
  data,
  // eslint-disable-next-line camelcase
  func_name,
  parameters,
  // eslint-disable-next-line camelcase
  cron_str,
  // eslint-disable-next-line camelcase
  cron_target,
  // eslint-disable-next-line camelcase
  cron_data,
}: ApiTaskResponse): ApiTask {
  return {
    name,
    admin,
    contract,
    hash,
    data,
    id: BigNumber(upkeep_id).toString(),
    amount: new BigNumber(amount),
    funcName: func_name,
    params: parameters,
    cronDate: cron_str,
    cronTarget: cron_target,
    cronData: cron_data,
  };
}
